export const uk = {
    cancel: 'Отменить',
    'set-smart-center': 'Установить смарт-центр',
    'smart-center-title': 'Смарт-центр'
};
